import React from 'react';
import { ContainerComponent, wrap } from 'AppReact';
import Calendar from 'containers/calendar';
import Controller from './controller';
import KeyInput from 'atoms/keyInput';
import { RelativeWrapper, DropdownOuterWrapper, DropdownWrapper, GenericWrapper } from 'wrappers';
import internalState from './internalState';

const containerRef = React.createRef();

export const definition = {
  name: 'DatePicker',
  controller: Controller,
  initialProps: ({ selectedDate, isBorder, placeholder }) => ({ selectedDate, isBorder, placeholder }),
  props: internalState,
  elements: [
    {
      name: 'Selector',
      isButton: true,
      bindings: ({ isOpen }) => ({ isOpen, containerRef }),
      wrapper: GenericWrapper,
      elements: [
        {
          component: KeyInput,
          name: 'Input',
          displayState: ({ isBorder }) => ({ isBorder }),
          bindings: ({ entryVal, selectedDate, placeholder }) => ({ entryVal, value: entryVal || (selectedDate?.toLocaleDateString?.() || ''), placeholder: placeholder ?? 'Date' })
        }
      ]
    },
    {
      wrapper: DropdownOuterWrapper,
      name: "CalendarOuterWrapper",
      ref: containerRef,
      renderIf: ({ isOpen }) => isOpen,
      elements: [
        {
          wrapper: DropdownWrapper,
          name: "CalendarWrapper",
          elements: [
            {
              component: Calendar,
              name: 'Calendar',
              bindings: ({ selectedDate }) => {
                const month = selectedDate?.getMonth?.() || 5
                const year = selectedDate?.getFullYear?.() || 2020
                return { selectedDate, month, year }
              }
            }
          ]
        }
      ]
    }

  ]
}

const DatePicker = ContainerComponent(definition)

export default wrap(DatePicker, RelativeWrapper)